module.exports = __webpack_public_path__ + "static/media/dark-theme-fuel-fill.a9673433.svg";